import styled from 'styled-components'

export const StyledUpload = styled.div`
  .images-container {
    margin: 10px 0;
  }
  .image {
    margin: 5px;
    position: relative;
    button {
      position: absolute;
      right: 2px;
      top: 2px;
    }
  }
`
